import React, { FC, useEffect, useRef, useState } from "react";
import SuccessToast from "../../cards/toast";
import { useTranslate } from "@tolgee/react";
import { useSelector } from "react-redux";
import { lomavisCreatorRootState } from "../../../../pages/lomavisCreator";
import {
  ALL,
  PLATFORM_LIST,
  PLATFORM_LIST_NAMES,
} from "../../../../config/constants";
import { AddImageButton, EditorHeader } from "../sharedComponents";
import { POST_TYPE_KEY, platformFeatures } from "../../config/platformFeatures";
import { MEDIA_TYPE_VIDEO } from "../../config/constants";
import { PLATFORM_COLORS, PLATFORM_ICONS } from "../../../../config/icons";
import VideoEditor from "./videoEditor";
import { relocatePublishButtons } from "../../utils/uploadMediaFile";
import toast from "react-hot-toast";
import { number } from "echarts";
import { current } from "@reduxjs/toolkit";

interface Props {
  handleClose: Function;
  platform: string;
  newUploadedAsset: any[];
  count: Number;
  handleCloseNoConfirmation: Function;
  setCurrentIndex: React.Dispatch<React.SetStateAction<number>>;
  currentIndex: string | number;
  totalItemsInUpload: string | number;
  scrollToTop: Function;
}
const VideoModifier: FC<Props> = ({
  handleClose,
  platform,
  newUploadedAsset,
  count,
  handleCloseNoConfirmation,
  setCurrentIndex,
  currentIndex,
  totalItemsInUpload,
  scrollToTop,
}) => {
  const { t } = useTranslate();

  const [rightMargin, setRightMargin] = useState(0);
  const [synchronousEditing, setSynchronousEditing] = useState(true);
  const [startSubmission, setStartSubmission] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const fileInputRef = useRef(null);
  const footerRef = useRef(null);

  const platformEnabled = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.platformEnabled
  );
  const postData = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.postData
  );
  const allEnabledPlatforms = PLATFORM_LIST.filter(
    (item) => platformEnabled[item] === true
  );
  const typeKey = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.postTypeSelected
  );

  const postTypeRule = (platform) => {
    return platformFeatures[platform][POST_TYPE_KEY]?.find(
      (pt) => pt.typeKey === typeKey[platform]
    );
  };

  const postMediaData = (platform) => {
    return postData[platform].media?.find(
      (file) =>
        file.media_type === MEDIA_TYPE_VIDEO &&
        file.uuid === newUploadedAsset[currentIndex].uuid
    );
  };

  const [editorArrayInfo, setEditorArrayInfo] = useState(
    platform === ALL
      ? allEnabledPlatforms.map((platform) => {
          return {
            platform: platform,
            aspectRatio: 1,
            name: PLATFORM_LIST_NAMES?.[platform],

            newEdit: {},
            videoInfo: newUploadedAsset[currentIndex],
            count: count,

            maxVideos: postTypeRule(platform).mediaTypes?.video?.enabled
              ? postTypeRule(platform).mediaTypes?.video?.maxFiles
              : null,
          };
        })
      : [
          {
            platform: platform,
            aspectRatio: 1,
            name: PLATFORM_LIST_NAMES?.[platform],

            newEdit: {},
            videoInfo: newUploadedAsset[currentIndex],
            maxVideos: postTypeRule(platform).mediaTypes.image.enabled
              ? postTypeRule(platform).mediaTypes.image.maxFiles
              : null,
            count: count,
          },
        ]
  );
  const triggerSuccessToast = () => {
    toast.success(t("lomavisCreator.video.saved"), {
      position: "top-right",
      id: "accounts.invites.table.invite_deleted",
    });
  };

  useEffect(() => {
    relocatePublishButtons({
      footerRef: footerRef,
      setRightMargin: setRightMargin,
    });
  }, []);

  return (
    <div className="d-flex flex-column w-100 h-100 gap-4">
      <SuccessToast show={showToast} onClose={() => setShowToast(false)} />
      <EditorHeader>
        {" "}
        <div className="d-flex justify-content-between align-items-center flex-fill h-100 main_editor">
          <div className="h-100 w-100 d-flex justify-content-start align-items-center gap-3 flex-fill">
            {editorArrayInfo.map((editor) => (
              <i
                className={PLATFORM_ICONS[editor.platform] + " fs-1 me-2"}
                style={{
                  color: PLATFORM_COLORS[editor.platform],
                }}
              ></i>
            ))}
          </div>{" "}
          <div className="flex-fill w-50 d-flex flex-end">
            <AddImageButton
              handleClick={() => fileInputRef.current?.click()}
              disabled={startSubmission}
            />
          </div>
        </div>
      </EditorHeader>
      <div
        style={{ overflowY: "auto" }}
        className="d-flex w-100 gap-4 flex-fill"
      >
        <VideoEditor
          EditorArrayInfo={editorArrayInfo}
          startSubmission={startSubmission}
          platform={platform}
          selectedFile={postMediaData(platform)}
          footerRef={footerRef}
          rightMargin={rightMargin}
          setStartSubmission={setStartSubmission}
          handleClose={handleClose}
          fileInputRef={fileInputRef}
          successNotification={() => triggerSuccessToast()}
          handleCloseNoConfirmation={handleCloseNoConfirmation}
          setCurrentIndex={setCurrentIndex}
          currentIndex={currentIndex}
          totalItemsInUpload={totalItemsInUpload}
          scrollToTop={scrollToTop}
        />
      </div>
    </div>
  );
};

export default VideoModifier;
